import React, { useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import { SmsFactorStatuses } from 'constants/mfa';
import {
  sendSmsFactorOTP,
  verifySmsFactor,
} from 'redux/actions/smsFactor.actions';
import {
  getSmsFactorPhoneNumber,
  getSmsFactorStatus,
} from 'redux/selectors/smsFactor.selectors';
import { getErrorMessage } from 'redux/selectors/ui.selectors';

import CreateSmsFactor from './CreateSmsFactor';
import SignInAnimation from './SignInAnimation';
import VerifySmsFactor from './VerifySmsFactor';

const MfaSmsRoot = ({ status, smsVerifyError, smsOTPSendingError }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const dispatch = useDispatch();
  const phoneNumber = useSelector(getSmsFactorPhoneNumber);
  if (isVerified) {
    return <SignInAnimation />;
  }

  if (status === null || isEditing) {
    return <CreateSmsFactor status={status} setIsEditing={setIsEditing} />;
  }

  const handleSave = code => {
    dispatch(
      verifySmsFactor(
        {
          phoneNumber,
          code,
        },
        {
          onSuccess: () => setIsVerified(true),
        },
      ),
    );
  };

  const handleSend = () => {
    dispatch(
      sendSmsFactorOTP({
        phoneNumber,
      }),
    );
  };

  const handleChangeNumber = () => {
    setIsEditing(true);
  };

  if (status === SmsFactorStatuses.PENDING) {
    return (
      <VerifySmsFactor
        status={status}
        setIsVerified={setIsVerified}
        phoneNumber={phoneNumber}
        onSendCode={handleSend}
        onSubmit={handleSave}
        handleChangeNumber={handleChangeNumber}
        smsVerifyError={smsVerifyError}
        smsOTPSendingError={smsOTPSendingError}
        showCreateAccountHeader={true}
        canChangeNumber={true}
      />
    );
  }

  if (status === SmsFactorStatuses.ACTIVE) {
    return (
      <VerifySmsFactor
        status={status}
        setIsVerified={setIsVerified}
        phoneNumber={phoneNumber}
        onSendCode={handleSend}
        onSubmit={handleSave}
        handleChangeNumber={handleChangeNumber}
        smsVerifyError={smsVerifyError}
        smsOTPSendingError={smsOTPSendingError}
        showCreateAccountHeader={false}
        canChangeNumber={true}
      />
    );
  }

  return null;
};

const mapStateToProps = state => ({
  status: getSmsFactorStatus(state),
  smsVerifyError: getErrorMessage(state, 'verifySmsFactor'),
  smsOTPSendingError: getErrorMessage(state, 'sendSmsFactorOTP'),
});

export default connect(mapStateToProps)(MfaSmsRoot);
